// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"98f9f326","251":"5714c9fa","258":"d7851951","294":"c0c67bc1","453":"4cca77cb","488":"9e4caeb9","730":"ff1a4f9c","780":"0229a5df","982":"be87c3c8","983":"6708acc9"}[chunkId] + ".chunk.js";
};